<template>
  <div class='CategoryList'>
    <div class="nome">
      {{ data.nome }}
    </div>
    <div class="acoes">
      <img v-if="data.img.length" @click="$refs.in.click()" :src="api + data.img">
      <img-icon @click="$refs.in.click()" v-if="!data.img.length" :options="{ width: '35px', height: '25px', color: '#CCCCCC', action: true }"/>
      <delete-icon @click="$emit('del', data)"/>
    </div>
    <input ref="in" v-show="false" type="file" @change="inFile"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DeleteIcon from '../Icons/DeleteIcon'
import ImgIcon from '../Icons/ImgIcon'
import api from '@/mixins/api'
import compressImage from '@/mixins/compressImage'
export default {
  name: 'CategoryList',
  components: { DeleteIcon, ImgIcon },
  props: ['data'],
  mixins: [api, compressImage],
  methods: {
    ...mapActions(['_UpdateFrenteLojaCategoria']),
    inFile (e) {
      for (let key in e.target.files) {
        if (key !== 'length' && key !== 'item') {
          this.getBase64(e.target.files[key])
        }
      }
    },
    getBase64 (file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = async () => {
        this._UpdateFrenteLojaCategoria({ id: this.data.id, img: await this.compressImage(reader.result), filename: file.name })
          .then(() => {
            this.$emit('updateimg', this.data.id + file.name)
          })
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    }
  }
}
</script>

<style scoped>
.CategoryList {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
}

.nome {
  flex: 1;
  text-align: left;
  padding: 10px 12px;
  border-radius: 5px;
  border: thin solid #CCCCCC;
}

.acoes {
  width: 150px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 3px;
  cursor: pointer;
}
</style>
